export const ADD_PRODUCT_DETAILS_REQUEST = "ADD_PRODUCT_DETAILS_REQUEST";
export const ADD_PRODUCT_DETAILS_SUCCESS = "ADD_PRODUCT_DETAILS_SUCCESS";
export const ADD_PRODUCT_DETAILS_FAIL = "ADD_PRODUCT_DETAILS_FAIL";

export const FETCH_PRODUCT_DETAILS_REQUEST = "FETCH_PRODUCT_DETAILS_REQUEST";
export const FETCH_PRODUCT_DETAILS_SUCCESS = "FETCH_PRODUCT_DETAILS_SUCCESS";
export const FETCH_PRODUCT_DETAILS_FAIL = "FETCH_PRODUCT_DETAILS_FAIL";

export const FETCH_ACTIVE_PRODUCT_DETAILS_REQUEST = "FETCH_ACTIVE_PRODUCT_DETAILS_REQUEST";
export const FETCH_ACTIVE_PRODUCT_DETAILS_SUCCESS = "FETCH_ACTIVE_PRODUCT_DETAILS_SUCCESS";
export const FETCH_ACTIVE_PRODUCT_DETAILS_FAIL = "FETCH_ACTIVE_PRODUCT_DETAILS_FAIL";

export const FETCH_INACTIVE_PRODUCT_DETAILS_REQUEST = "FETCH_INACTIVE_PRODUCT_DETAILS_REQUEST";
export const FETCH_INACTIVE_PRODUCT_DETAILS_SUCCESS = "FETCH_INACTIVE_PRODUCT_DETAILS_SUCCESS";
export const FETCH_INACTIVE_PRODUCT_DETAILS_FAIL = "FETCH_INACTIVE_PRODUCT_DETAILS_FAIL";

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL";